export default __webpack_public_path__ + "static/media/misc-closet2-480w.771c3489.webp";